import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useContext, createContext, useState } from "react";
import { getstg } from '../../utils';
const UserContext = createContext(null);
export const useUserContext = () => {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error("UserContext must be used within a UserContextProvider");
    }
    return context;
};
export const UserContextProvider = ({ debug, children }) => {
    const [userContext, setUserContext] = useState(null);
    const saveUserContext = (ctx) => {
        setUserContext(ctx);
    };
    useEffect(() => {
        const stg = getstg();
        const uctx = {
            user: stg.user
        };
        setUserContext(uctx);
    }, []);
    return (_jsx(UserContext.Provider, { value: { data: userContext, save: saveUserContext }, children: children }));
};
